import {ObjectUtil} from '../../util/object-util';
import {ProposalUser} from './proposalUser';

export class LeadingOfferInfo {
  leadingOfferId: string = null;
  userId: string = null;
  amountCovered: number = null;

  standardTermsAndConditions: string[] = [];
  standardClauses: string[] = [];
  individualTermsAndConditions: string = null;
  individualClauses: string = null;

  premium: number = null;
  expectedTotalPremium: number = null;
  advancePremium: number = null;
  minimumPremium: number = null;
  premiumInPercent: number = null;
  premiumPerThousand: number = null;

  currency: string = null;
  typeOfDeductible: string = null;
  deductibleAbsoluteAmount: number = null;
  deductibleCurrency: string = null;

  creator: ProposalUser = null;

  public constructor(object?: Object) {
    ObjectUtil.assign(this, object);

    if (object != null) {
      if (Object.keys(object).includes('creator')) {
        this.creator = new ProposalUser(object['creator']);
      }
    }
  }
}
